import React, { Component } from "react";
import { sidemenuFooterWrap } from "../componentCommon";
import { Col, Row } from "react-styled-flexboxgrid";
import Form from "react-bootstrap/Form";
import "../../index.scss";

let SearchTermsTable = () => (
  <div className="search-table">
    <p>PRETRAŽIVANJE</p>
    <br />

    <form
      style={{
        marginLeft: "0%",
        fontWeight: "200",
        fontFamily: "Verdana, arial"
      }}
    >
      <table style={{ width: "40em", border: "0" }}>
        <tr>
          <td align="center">&nbsp;</td>
          <td>odrednica </td>
          <td>
            <select name="select_id_odrednice">
              <option value="" selected>
                &nbsp;
              </option>
              <option value="1">Petar Lubarda</option>
              <option value="2">Sava Šumanović</option>
              <option value="3">Muzej savremene umetnosti</option>
              <option value="4">Avangarda</option>
              <option value="5">Nadežda Petrović</option>
            </select>
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>prezime autora &nbsp;</td>
          <td>
            <input type="text" name="prezime_autora" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>ime autora</td>
          <td>
            <input type="text" name="ime_autora" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>naslov</td>
          <td>
            <input type="text" name="naslov" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>izdava&#269;</td>
          <td>
            <input type="text" name="izdavac" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>godina izdanja</td>
          <td>
            <input type="text" name="godina_izdanja" size="15" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>mesto izlo&#382;be</td>
          <td>
            <input type="text" name="mesto_izlozbe" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>godina izlo&#382;be</td>
          <td>
            <input type="text" name="godina_izlozbe" size="15" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>

        <tr>
          <td>&nbsp;</td>
        </tr>

        <tr>
          <td align="center">&nbsp;</td>
          <td>klju&#269;na re&#269;</td>
          <td>
            <input type="text" name="kljucna_rec" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>
      </table>
      <br />
      <br />
      &nbsp;&nbsp;&nbsp;
      <input type="submit" name="potvrdi" value="NAĐI" />
    </form>

    <br />
    <br />
    <p>FOTO PRETRAGA</p>
    <br />

    <form target="_blank">
      <table width="614" border="0">
        <tr>
          <td align="center">&nbsp;</td>
          <td>klju&#269;na re&#269;</td>
          <td>
            <input type="text" name="kljucna_rec_foto" size="40" />
          </td>
          <td align="center">&nbsp;</td>
          <td align="center">&nbsp;</td>
        </tr>
      </table>
      <br />
      <br />
      &nbsp;&nbsp;&nbsp;
      <input type="submit" name="potvrdi" value="NAĐI" />
    </form>
  </div>
);


export default sidemenuFooterWrap(SearchTermsTable);
 